import styled from 'styled-components';
import { StyledCalendar } from './Calendar.js/Calendar.style';

export const CALENDAR_COLORS = {
  TODAY: '#BDC1C6',
  DUE_DATE: '#9747FF'
};

export const StyledCalendarView = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  & ${StyledCalendar} {
    margin-right: 15rem;
    position: relative;
    bottom: 3rem;
  }
`;
